<script setup lang="ts">
import { computed, watch } from "vue";
import MPImg from "./MPImg.vue";
import { callOnce, useCreators } from "#imports";

const props = withDefaults(
  defineProps<{
    creatorId: string;
    withLink?: boolean;
  }>(),
  {
    withLink: true,
  },
);

const creatorStore = useCreators();

const creator = computed(() => creatorStore.getById(props.creatorId).value!);

const loadData = async () => {
  await creatorStore.fetchById(props.creatorId);
};

// we have to make the key unique to the component because otherwise it won't run more than once
await callOnce(`MPCreatorTag-${props.creatorId}`, loadData, {
  mode: "navigation",
});
watch(() => props.creatorId, loadData);
</script>

<template>
  <NuxtLinkLocale
    v-if="withLink"
    :to="`/@${creator.mappr_handle}`"
    class="creatortag-container"
  >
    <MPImg
      class="profile-image"
      :src="creator.profile_image_url ?? '/media/images/placeholder-user.webp'"
      :width="40"
      :height="40"
    />
    <div class="creatortag-name typeface-small">
      Selected by<br />
      <strong class="typeface-regular">@{{ creator.mappr_handle }}</strong>
    </div>
  </NuxtLinkLocale>
  <div v-else class="creatortag-container">
    <MPImg
      class="profile-image"
      :src="creator.profile_image_url ?? '/media/images/placeholder-user.webp'"
      :width="40"
      :height="40"
    />
    <div class="creatortag-name typeface-small">
      Selected by<br />
      <strong class="typeface-regular">@{{ creator.mappr_handle }}</strong>
    </div>
  </div>
</template>

<style lang="postcss" scoped>
.creatortag-container {
  display: flex;
  align-items: center;
  width: fit-content;

  .profile-image {
    border-radius: 100%;
    width: 2.25rem;
    height: 2.25rem;
  }

  .creatortag-name {
    padding: 0 1rem 0 0.5rem;
    white-space: nowrap;
    color: inherit;
    strong {
      font-weight: 700;
    }
  }
}
</style>
